import { Container } from "@/components/ui/Container";
import { Button } from "@/components/ui/Button";
import { BackgroundGrid } from "@/components/layout/BackgroundGrid";
import { OpenSignupButton } from "@/components/popups/OpenSignupButton";

export function NotFoundContent() {
  return (
    <section className="relative flex min-h-[70vh] items-center overflow-hidden py-24">
      <BackgroundGrid />
      <Container className="relative text-center">
        <p className="font-mono text-sm uppercase tracking-[0.12em] text-accent-lime">Erro 404</p>
        <h1 className="mt-4 text-3xl font-bold uppercase tracking-tight text-text-primary sm:text-4xl">
          Essa página não está no ar.
        </h1>
        <p className="mx-auto mt-4 max-w-md text-text-secondary">
          O link pode ter mudado ou o conteúdo não existe mais. Volte para a home ou fale
          diretamente com um especialista.
        </p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-4">
          <Button href="/">Voltar para a home</Button>
          <OpenSignupButton variant="secondary">Falar com um especialista</OpenSignupButton>
        </div>
      </Container>
    </section>
  );
}
